import { create } from 'zustand'

interface LocationStoreState {
  selectedLocationIds: string[] | null
}

interface LocationStoreActions {
  setSelectedLocationIds: (ids: string[] | null) => void
  reset: () => void
}

type LocationStore = LocationStoreState & LocationStoreActions

const initialState: LocationStoreState = {
  selectedLocationIds: null,
}

export const useLocationStore = create<LocationStore>()((set) => ({
  ...initialState,

  setSelectedLocationIds: (ids) => set({ selectedLocationIds: ids }),

  reset: () => set(initialState),
}))
